// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"styles_breadcrumbs__wNfoC","item":"styles_item__GMCbi","link":"styles_link__Y6gVo","active":"styles_active__XpmlL","icon":"styles_icon__hcu56"};